import * as THREE from 'three';
import {
	CARD1Web,
	ThreeExt
} from './CoordUtils.js';
import './thirdparty/loaders/DRACOLoader'
import './thirdparty/loaders/GLTFLoader'
import './thirdparty/Car.js'

export class Car {
	constructor() {
			this.carParts = {
				body: [],
				rims: [],
				glass: [],
			};
			this.car = new ThreeExt.Car();

		}
		load(onLoaded, onProgress) {
			var _this = this;
			ThreeExt.DRACOLoader.setDecoderPath('/static/bimroad/libs/draco/gltf/');
			var loader = new ThreeExt.GLTFLoader();
			loader.setDRACOLoader(new ThreeExt.DRACOLoader());
			loader.load('/static/bimroad/models/ferrari/ferrari.glb', function(gltf) {
				_this.carModel = gltf.scene.children[0];
				_this.carModel.scale.set(0.6, 0.6, 0.6);
				
				// add lightHolder to car so that the shadow will track the car as it moves
				_this.car.setModel(_this.carModel);
				_this.carModel.traverse(function(child) {
					if (child.isMesh) {
						child.castShadow = true;
						child.receiveShadow = true;
					}
				});
				
				// car parts for material selection
				_this.carParts.body.push(_this.carModel.getObjectByName('body'));
				_this.carParts.rims.push(
					_this.carModel.getObjectByName('rim_fl'),
					_this.carModel.getObjectByName('rim_fr'),
					_this.carModel.getObjectByName('rim_rr'),
					_this.carModel.getObjectByName('rim_rl'),
					_this.carModel.getObjectByName('trim'),
				);
				_this.carParts.glass.push(
					_this.carModel.getObjectByName('glass'),
				);
				//设置玻璃的透明度
				_this.carParts.glass.map(item=>{
					item.material.transparent = true;
					item.material.opacity = 0.2;	
				});
				onLoaded.call();
				//updateMaterials();
			}, onProgress);
		}

		setPosition(position){
			this.carModel.copy(position);
		}

		getPosition(){
			return this.carModel.position;
		}

		addToScene(scene){
			scene.add(this.carModel);
		}
		lookAt(position){
			this.carModel.lookAt(position);
			this.carModel.rotateY(Math.PI);
		}

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/car.js